<template>
  <b-modal
    :id="id"
    ref="bModal"
    size="lg"
    :title="$t('registry.cases.patientCases')"
    centered
    modal-class="patient-cases"
    @hide="onHide"
  >
    <b-card
      v-if="patient"
      class="patient-card mb-1 py-1 mx-2"
    >
      <b-row style="width:100%">
        <b-col
          xl="4"
          lg="4"
          class="d-flex align-items-center"
        >
          <div class="main-info d-flex align-items-center">
            <i
              class="fal fa-user-circle mr-2 main"
              style="cursor:pointer"
              aria-hidden="true"
              @click="showModal"
            />
            <span>{{ patient.fullName }}</span>
            <vtBubble
              :number="mockupValue.incidentBubble"
              :type="true"
              :tooltip="` ${$t('grid.detail.hasAlarms')}`"
              class="ml-1"
            />
            <vtBubble
              :number="mockupValue.attachBubble"
              :type="false"
              :tooltip="` ${$tc('global.file',2)}`"
            />
          </div>
        </b-col>
        <b-col
          xl="8"
          lg="8"
          class="pr-0"
        >
          <b-row>
            <b-col>
              <b-row class="gr-card-info">
                <b-col class="info text-center">
                  <div>
                    <small>{{ patient.centerIdentifierType }}</small>
                  </div>
                  <div>
                    <span style="font-size:.9rem;color:#303133">{{ patient.centerIdentifier }}</span>
                  </div>
                </b-col>
                <b-col class="info text-center">
                  <div>
                    <small>{{ patient.personIdentifierType }}</small>
                  </div>
                  <div>
                    <span style="font-size:.9rem;color:#303133">{{ patient.personIdentifier }}</span>
                  </div>
                </b-col>
                <b-col class="info text-center">
                  <div>
                    <small>{{ $t('entities.patient.gender') }}</small>
                  </div>
                  <div>
                    <span
                      style="font-size:.9rem;color:#303133"
                    >{{ patient.genderName }}</span>
                  </div>
                </b-col>
                <b-col class="info text-center">
                  <div>
                    <small>{{ $t('entities.patient.birthdate') }}</small>
                  </div>
                  <div>
                    <span style="font-size:.9rem;color:#303133">{{ patient.patBirthdate | date }}</span>
                  </div>
                </b-col>
                <b-col class="info text-center d-xl-block">
                  <div>
                    <small>{{ $t('global.age') }}</small>
                  </div>
                  <div>
                    <span
                      style="font-size:.9rem;color:#303133"
                    >{{ patientTimeOld }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-row
      class="px-2 py-0"
      style="height:30px;"
    >
      <b-col class="pt-2">
        <span class="title">{{ $tc('global.case',2) }} ({{ rowData.length }})</span>
      </b-col>
      <!-- TODO: Hay que darle funcionalidad a ambos botones -->
      <b-col
        v-if="selectedRows.length === 1"
        cols="auto"
        class="d-flex justify-content-end"
      >
        <b-button
          v-tooltip="$t('component.modalPatientCases.dumpCase')"
          class=" btn__icon btn__icon--primary px-2"
        >
          <i
            class="far fa-cabinet-filing"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-tooltip="$t('component.patient.searcher.viewCases')"
          class=" btn__icon btn__icon--primary px-2"
        >
          <i
            class="far fa-download"
            aria-hidden="true"
          />
        </b-button>
      </b-col>
    </b-row>
    <vt-grid
      v-if="patient"
      class="ps-grid mt-2"
      :detail-cell-renderer="detailCellRenderer"
      :master-detail="true"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :framework-components="frameworkComponents"
      :row-data="rowData"
      :detail-row-height="500"
      component-code="uicomponent.registry.patientcasegrid"
    />
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-2 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-10 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="printReport"
          >
            <i
              class="fas fa-print mr-2"
              aria-hidden="true"
            />
            {{ $t('component.modalPatientCases.printPreviews') }}
          </b-button>
        </div>
      </div>
    </div>
    <modal-associated-cases-list ref="associatedCasesListModal" />
    <modal-patient-card
      v-if="patient"
      id="modalPatientCard"
      ref="modalPatientCard"
      :patient-id="patient.patId || patient.id"
    />
  </b-modal>
</template>

<script>
import ModalPatientCard from '@/components/modals/ModalPatientCard'
import VtBubble from '@/components/common/VtBubble'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import VtGrid from '@/components/VtGrid/VtGrid'
import caseServices from '@/api/resources/common/commonCaseServices'
import patientCasesColumnsDef from '@/components/patientPreviousCases/config/patientCasesColumnsDef'
import PatientTabsCellRenderer from '@/components/patientPreviousCases/PatientTabsCellRenderer'
import ModalAssociatedCasesList from '@/components/patientPreviousCases/ModalAssociatedCasesList'
import Encoder from '@/utils/encoder'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'ModalPatientCases',
    components: {
        ModalPatientCard,
        VtBubble,
        VtGrid,
        ModalAssociatedCasesList
    },
    props: {
        id: { type: String, required: true },
        content: { type: String },
        okTitle: { type: String, default: 'global.close' },
        cases: { type: Array }
    },
    data() {
        return {
            // TODO: Esta mockeado el valor de incidencias y adjuntos
            mockupValue: {
                attachBubble: 3,
                incidentBubble: 2
            },
            patient: null,
            selectedRows: [],
            rowData: [],
            columnDefs: patientCasesColumnsDef(),
            gridApi: null,
            isHide: true,
            patId: null,
            encoder: new Encoder(),
            contentOverride: null,
            selected: null,
            detailCellRenderer: 'detailCellRenderer',
            frameworkComponents: { detailCellRenderer: PatientTabsCellRenderer },
            options: [
                { value: null, text: '' },
                { value: 'a', text: 'Opción 1' },
                { value: 'b', text: 'Opción 2' },
                { value: 'b', text: 'Opción 3' }
            ]
        }
    },
    computed: {
        gridOptions() {
            return {
                pagination: false,
                getContextMenuItems: this.getContextMenuItems,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                floatingFilter: false,
                sideBar: gridSideBarConfig,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        },
        displayContent() {
            return this.contentOverride || this.content
        },
        patientTimeOld() {
            return this.patient && this.getPatientTimeOld(this.patient.patBirthdate)
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        showAssociatedCasesListModal(casId) {
            this.$refs.associatedCasesListModal.show(casId)
        },
        getContextMenuItems(params) {
            if (this.selectedRows.length <= 1) {
                return [
                    {
                        // TODO: Hay que darle funcionalidad a las opciones del menú contextual
                        name: this.$t('component.modalPatientCases.dumpCase')
                    },
                    {
                        name: this.$t('component.patient.searcher.viewCases')
                    },
                    {
                        name: this.$t('component.modalPatientCases.viewAssociatedCases'),
                        action: () => this.showAssociatedCasesListModal(params?.node.data.casId)
                    }
                ]
            }
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
            this.getRowData()
        },
        async getRowData() {
            if (!this.cases) {
                const cases = await caseServices.getPreviousCases(
                    this.labId,
                    this.patient.patId || this.patient.id
                )
                this.rowData = cases.content
            } else {
                this.rowData = this.cases
            }
        },
        show(patient) {
            this.patient = patient
            this.$refs.bModal.show()
        },
        showModal() {
            this.$refs['modalPatientCard'].show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHide() {
            this.contentOverride = null
            this.patient = null
            this.$emit('onHide')
        },
        printReport() {
            this.printPatientPreviousCasesPDF(this.labId, this.patient.patId || this.patient.id)
        }
    }
}
</script>

<style lang="scss">
.patient-cases .vt-tabs .nav-tabs .nav-link,
.vt-tabs--small .nav-tabs .nav-link {
  letter-spacing: 0;
  font-weight: 700;
  font-size: font-size(small);
}

.patient-cases .vt-tabs .nav-tabs .nav-link.active,
.vt-tabs--small .nav-tabs .nav-link.active {
  border-bottom: 2px solid vt-color(primary);
}

.patient-cases .vt-tabs .nav-tabs .nav-link,
.vt-tabs--small .nav-tabs .nav-link {
  border-bottom: 2px solid transparent;
}

.patient-cases .nav-tabs .nav-link {
  border-radius: 2px;
}

.patient-cases .modal-dialog {
  max-width: 75%;
}

.patient-cases .modalPatientCard .modal-dialog {
  max-width: 60%;
}

.patient-cases .ps-grid {
  overflow-y: auto;
  height: calc(100vh - 250px) !important;
}

.patient-cases .flex-btn {
  width: 5% !important;
}

.patient-cases .ag-status-bar {
  display: none;
}

@media (max-width: 1300px) {
  .patient-cases .modal-dialog {
    max-width: 96%;
  }

  .patient-cases .modalPatientCard .modal-dialog {
    max-width: 80%;
  }
}
</style>

<style lang="scss" scoped>
.title {
  font-size: font-size(normal);
  color: vt-color(primary);
}

.patient-card {
  height: 40px;
  box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
}

.patient-card .card-info span {
  font-size: font-size(very-small);
  color: vt-color(dark-text);
}

.patient-card .main-info i {
  font-size: font-size(big);
}

.patient-card .main-info span {
  font-size: font-size(very-small);
  color: vt-color(dark-text);
}

.patient-card .floating {
  right: 10px;
  top: 0;
}

.patient-card .card-body {
  display: flex;
  align-items: center;
  padding-right: 0;
}

.header-grid {
  background-color: #fff !important;
  border: 1px solid #d8d8d8;
  border-left: 4px solid vt-color(primary);
}

.check-text {
  font-size: 0.9rem;
}
</style>
